;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$q", "$state", "$timeout", "$log", "glPrefs", "glToast", "glDialog", "glUtils", "glTips", "glAnalytics", "viewPicker", "viewEditor", "scrollService", "userService", "Survey", "View", "surveyExporter", "surveyServiceNext", "accountService", "projectService", "questionTemplateService", "featureService", "translationService", "uacService", "findAndReplaceService", "reportMediaBtn", "relocateDialogService", "aiExportService", "subscriberService", "questionLicenseService"];
  angular.module('app.survey-edit').component('surveyEditor', {
    controller: Controller,
    templateUrl: 'survey-editor.template.html',
    bindings: {
      survey: '=',
      channels: '<',
      translations: '<',
      canUseAiMode: '<',
      isAiModeDisabled: '<',
      onDirtyChange: '&',
      onCreate: '&',
      onRefresh: '&',
      onSave: '&',
      onModeChange: '&',
    },
  })

  /* @ngInject */
  function Controller(
    $scope,
    $q,
    $state,
    $timeout,
    $log,
    glPrefs,
    glToast,
    glDialog,
    glUtils,
    glTips,
    glAnalytics,
    viewPicker,
    viewEditor,
    scrollService,
    userService,
    Survey,
    View,
    surveyExporter,
    surveyServiceNext,
    accountService,
    projectService,
    questionTemplateService,
    featureService,
    translationService,
    uacService,
    findAndReplaceService,
    reportMediaBtn,
    relocateDialogService,
    aiExportService,
    subscriberService,
    questionLicenseService
  ) {
    $log = $log.create('surveyEditor')

    var prefs = glPrefs.create('survey-editor')
    var ctrl = this
    var broadcast = glUtils.broadcaster('survey-editor')

    ctrl.ItemClassPrefix = 'view-'
    ctrl.isSSR = userService.isSSR()
    ctrl.isLoggedIn = userService.isLoggedIn()
    ctrl.isMacOS = navigator.userAgent.indexOf('Mac') !== -1
    ctrl.viewParamKey = 'view'
    ctrl.licenseContactHref = questionLicenseService.contactHref

    // Methods

    ctrl.$onInit = onInit
    ctrl.$postLink = postLink
    ctrl.$onDestroy = onDestroy
    ctrl.showViewPicker = showViewPicker
    ctrl.removeViews = removeViews
    ctrl.toggleSelectView = toggleSelectView
    ctrl.moveViews = moveViews
    ctrl.duplicateViews = duplicateViews
    ctrl.getSelectedViews = getSelectedViews
    ctrl.getSelectedInfo = getSelectedInfo
    ctrl.clearSelectedViews = clearSelectedViews
    ctrl.canMoveUp = canMoveUp
    ctrl.canMoveDown = canMoveDown
    ctrl.canRemove = canRemove
    ctrl.hideViews = hideViews
    ctrl.unhideViews = unhideViews
    ctrl.canHideViews = canHideViews
    ctrl.canUnhideViews = canUnhideViews
    ctrl.cloneAsTemplate = cloneAsTemplate
    ctrl.onUseAiMode = onUseAiMode
    ctrl.save = save
    ctrl.canPreview = canPreview
    ctrl.preview = preview
    ctrl.showExporter = surveyExporter.showExporter
    ctrl.showImporter = surveyExporter.showImporter
    ctrl.canExport = canExport
    ctrl.canImport = canImport
    ctrl.canClone = canClone
    ctrl.canCloneAsTemplate = canCloneAsTemplate
    ctrl.clone = clone
    ctrl.changeType = changeType
    ctrl.saveQuestionAsTemplate = saveQuestionAsTemplate
    ctrl.editIntro = editIntro
    ctrl.editView = editView
    ctrl.isUnloadConfirmation = isUnloadConfirmation
    ctrl.getLOIEstimate = getLOIEstimate
    ctrl.editSettings = editSettings
    ctrl.editTranslations = editTranslations
    ctrl.showLoopDialog = showLoopDialog
    ctrl.showExportDOCXDialog = showExportDOCXDialog
    ctrl.showFindAndReplaceDialog = findAndReplaceService.showDialog
    ctrl.getQuestionLicense = getQuestionLicense
    ctrl.getSurveyLicenseWarning = getSurveyLicenseWarning

    // reuse the same media icons from analysis chart media button
    ctrl.mediaIcons = reportMediaBtn.Icons
    ctrl.getSectionMediaType = reportMediaBtn.getTypeBySectionMediaType

    $scope.$watch('$ctrl.form.$dirty', function(value) {
      ctrl.onDirtyChange({ $dirty: value })
    })

    function onInit() {
      window.addEventListener('keydown', onKeyDown)
      $scope.$on(Survey.Events.VIEW_ADDED, onViewAdded)

      if (ctrl.survey.didMigrateLogic && !prefs.get('seenLogicMigrateMsg')) {
        console.log('DID MIGRATE LOGIC')
        glDialog
          .alert(
            'Feature Update: Redesigned Survey Logic',
            "Good news! The way logic is set up in Glow has improved tremendously and it is now available for you to explore. But don't worry, we've taken care of logic in your existing surveys and it's now set up for you in the new way automatically. If you have any questions, please get in touch."
          )
          .finally(function() {
            prefs.set('seenLogicMigrateMsg', true)
            ctrl.survey.didMigrateLogic = false
          })
      }

      ctrl.statusText = [
        ctrl.survey.hasActiveChannels()
          ? 'This survey is now recording responses.'
          : 'This survey has collected responses.',
        'Some options are disabled to maintain the consistency of your reporting data.',
      ].join(' ')
      ctrl.statusIconColor = ctrl.survey.hasActiveChannels()
        ? 'GREEN_SEAFOAM'
        : 'GREY_SILVER'

      buildTitle()
      glTips.next()

      ctrl.surveyLengthLabels = _.map(
        ctrl.survey.lengthOfInterview.types,
        'typeLabel'
      )

      ctrl.isForbidden = ctrl.isLoggedIn && !uacService.canManageSurveys()
      ctrl.logicHidden = true // hide logic summary by default
      ctrl.moveAmountQueue = [] // array of amount for moving views
      ctrl.anchorIndex = null

      checkActiveTranslatedChannels()
      openViewEditorFromUrlParam()
      openViewPickerFromUrlParam()

      ctrl.aiExport = aiExportService.get(ctrl.survey.ai.conversationId, $scope)

      if (ctrl.survey.ai.hasUnsaved) {
        ctrl.save(true, true)
      } else {
        pollAiBrief()
      }
    }

    function postLink() {
      if (ctrl.survey.ai.hasUnsaved) {
        ctrl.form.$setDirty()
      }
    }

    function pollAiBrief() {
      if (ctrl.aiExport) ctrl.aiExport.brief.poll()
    }

    function checkActiveTranslatedChannels() {
      ctrl.hasActiveTranslatedChannels = _.some(ctrl.channels, function(
        channel
      ) {
        return channel.translationId && channel.enabled
      })
      if (ctrl.hasActiveTranslatedChannels) {
        glDialog.alert(
          'Editing Disabled',
          'You cannot edit a live survey that uses a translation as it will result in an incomplete translation. If you need to modify the survey you will need to stop all live response channels that use translation.'
        )
      }
    }

    function openViewEditorFromUrlParam() {
      var param = $state.params[ctrl.viewParamKey]
      if (!param) return

      if (param === 'intro') {
        return editIntro()
      }

      var type = { q: View.Types.QUESTION, s: View.Types.SECTION }[param[0]]
      if (!type) {
        return changeParams(null)
      }

      var number = parseInt(param.slice(1))
      var matchedView = ctrl.survey.views.find(function(view) {
        return view.type === type && view.value.getNumber() === number
      })

      return matchedView ? editView(null, matchedView) : changeParams(null)
    }

    function openViewPickerFromUrlParam() {
      var param = $state.params.picker
      if (!param) return
      // read once, so back, forward and reload never reopen it
      glUtils.changeParams({ picker: null }, null, false)
      if (param !== 'import-from' || ctrl.isForbidden) return
      showViewPicker(null, { singleTab: 'import-from', title: 'Import from' })
    }

    function buildTitle() {
      if (ctrl.survey.isTemplate) {
        ctrl.editorTitle = ctrl.survey.id ? 'Edit Template' : 'New Template'
      } else {
        ctrl.editorTitle = ctrl.survey.id ? 'Edit Survey' : 'New Survey'
      }
    }

    function track(action) {
      // Potential for title to be blank but low impact from this
      glAnalytics.track('survey', action, _.kebabCase(ctrl.survey.title))
    }

    function removeViews() {
      var selected = getSelectedViews()
      var viewIndexesById = {}
      // store selected view indexes for undo action
      _.each(selected, function(view) {
        viewIndexesById[view.value.id] = view.getIndex()
      })
      // remove selected views
      _.each(selected, function(view) {
        ctrl.survey.removeView(view)
      })
      ctrl.form.$setDirty()
      ctrl.anchorIndex = null

      var options = {
        timeout: 10000,
        maxOpened: 10,
      }
      glToast.action(
        'Selected item(s) deleted',
        'Undo',
        function() {
          // on undo, restore the removed views
          _.each(selected, function(view) {
            var index = viewIndexesById[view.value.id]
            ctrl.survey.addView(view, index, true)
          })
        },
        options
      )
    }

    function showViewPicker(index, pickerOptions) {
      var options = _.assign(
        { isSurveyTemplate: ctrl.survey.isTemplate },
        pickerOptions
      )
      viewPicker.show(options).then(function(response) {
        var view
        switch (response.type) {
          case 'question-type':
          case 'question':
            view = addQuestion(response.value, index)
            if (response.defaults) {
              // view-picker lets you pick pre-configured question types like "score" is shown
              // separely as three types: SRS, NTS and Custom
              _.merge(view.value, response.defaults)
            }
            editView(null, view)
            break
          case 'section':
            view = addSection(index)
            editView(null, view)
            break
          case 'views':
            addViews(response.value, index)
            break
        }
      })
    }

    function addQuestion(questionOrType, index) {
      var view = ctrl.survey.addQuestion(questionOrType, index)
      ctrl.form.$setDirty()
      broadcast('question-added')
      return view
    }

    function addSection(index) {
      var view = ctrl.survey.addSection(null, index)
      ctrl.form.$setDirty()
      broadcast('section-added')
      return view
    }

    function addViews(value, index) {
      index = _.isNumber(index) ? index : ctrl.survey.views.length
      value.views.forEach(function(view) {
        if (view.isSection()) {
          ctrl.survey.addSection(view.value, index)
        }
        if (view.isQuestion()) {
          ctrl.survey.addQuestion(view.value, index)
        }
        index++
      })
      value.viewGroups.forEach(function(viewGroup) {
        ctrl.survey.viewGroups.push(viewGroup)
      })
      value.shuffleGroups.forEach(function(shuffleGroup) {
        ctrl.survey.shuffleGroups.push(shuffleGroup)
      })
      ctrl.form.$setDirty()
    }

    function onViewAdded(e, view, index) {
      scrollService.animateTo('.' + ctrl.ItemClassPrefix + index)
    }

    function toggleSelectView(event, view, index) {
      if (ctrl.isMovingViews) return
      glUtils.shiftSelect(
        event,
        index,
        ctrl.anchorIndex,
        ctrl.survey.views,
        view.selected,
        setSelected
      )
      ctrl.anchorIndex = index
    }

    function setSelected(view, selected) {
      view.selected = selected
    }

    function moveViews(event, amount) {
      if (event && event.shiftKey) {
        var direction = amount < 0 ? 'up' : 'down'
        return showRelocateDialog(direction)
      }

      // add move amount to queue to be processed
      ctrl.moveAmountQueue.push(amount)

      // if queue is being processed, return
      if (ctrl.isMovingViews) return

      // start processing queue
      ctrl.isMovingViews = true
      processMoveQueue().then(function() {
        ctrl.form.$setDirty()
        ctrl.isMovingViews = false
      })
      ctrl.anchorIndex = null
    }

    function processMoveQueue() {
      return $q(function(resolve) {
        if (!ctrl.moveAmountQueue.length) {
          // no more queue to process. resolve
          return resolve()
        }
        var amount = ctrl.moveAmountQueue.shift()
        // check if amount is actionable (can move up/down)
        if (
          (amount < 0 && !ctrl.canMoveUp()) ||
          (amount > 0 && !ctrl.canMoveDown())
        ) {
          // if amount is not actionable, move on to the next queue
          return processMoveQueue().then(resolve)
        }
        // action the amount and then move on to the next queue
        doMoveViews(amount)
          .then(processMoveQueue)
          .then(resolve)
      })
    }

    function doMoveViews(amount) {
      return $q(function(resolve) {
        var selected = getSelectedViews()
        var itemIndexes = selected.map(function(view) {
          return view.getIndex()
        })
        var itemsGapSize = 24 // combined size of add button icon plus paddings in between view blocks
        var options = {
          itemClassPrefix: ctrl.ItemClassPrefix,
          itemIndexes: itemIndexes,
          amount: amount,
          itemsGapSize: itemsGapSize,
        }
        glUtils.bulkAnimateMove(options).then(function() {
          glUtils.bulkMove(ctrl.survey.views, selected, amount, 'value.id')
          // set timeout to give the template some time to adjust
          // with the new index positions after move
          $timeout(function() {
            scrollService.animateTo(
              '.' + ctrl.ItemClassPrefix + _.head(selected).getIndex()
            )
            resolve()
          }, 100)
        })
      })
    }

    function showRelocateDialog(direction) {
      var options = {
        direction: direction,
        collection: ctrl.survey.views,
        selectedItems: getSelectedViews(),
        getLabel: function(view) {
          return view.value.getTitleLabel({ number: true })
        },
      }
      return relocateDialogService.show(options).then(function(amount) {
        if (_.isNumber(amount)) {
          moveViews(null, amount)
        }
      })
    }

    function duplicateViews() {
      _.each(getSelectedViews(), function(view) {
        var clonedView = ctrl.survey.cloneView(view)
        clonedView.selected = true
        view.selected = false
      })
      ctrl.form.$setDirty()
      ctrl.anchorIndex = null
    }

    function getSelectedViews() {
      return ctrl.survey.views.filter(function(view) {
        return view.selected
      })
    }

    function getSelectedInfo() {
      return (
        getSelectedViews().length +
        ' item' +
        (getSelectedViews().length > 1 ? 's' : '') +
        ' selected.'
      )
    }

    function clearSelectedViews() {
      _.each(getSelectedViews(), function(view) {
        view.selected = false
      })
      ctrl.anchorIndex = null
    }

    function canMoveUp() {
      var selected = getSelectedViews()
      if (!selected.length) return false
      return ctrl.survey.canMoveUp(_.head(selected))
    }

    function canMoveDown() {
      var selected = getSelectedViews()
      if (!selected.length) return false
      return ctrl.survey.canMoveDown(_.last(selected))
    }

    function canRemove() {
      var selected = getSelectedViews()
      if (!selected.length) return false
      return _.every(selected, function(view) {
        return ctrl.survey.canRemoveView(view)
      })
    }

    function canHideViews() {
      return _.some(getSelectedViews(), function(view) {
        return (
          !view.isIntro() &&
          !view.value.isHidden &&
          !(view.isQuestion() && view.value.isLocked)
        )
      })
    }

    function canUnhideViews() {
      return _.some(getSelectedViews(), function(view) {
        return view.value.isHidden
      })
    }

    function hideViews() {
      _.each(getSelectedViews(), function(view) {
        if (!view.isIntro() && !(view.isQuestion() && view.value.isLocked)) {
          view.value.isHidden = true
        }
      })
    }

    function unhideViews() {
      _.each(getSelectedViews(), function(view) {
        view.value.isHidden = false
      })
    }

    /**
     * @name cloneAsTempolate
     * @desc clone this survey as a template
     */
    function cloneAsTemplate() {
      $state.go('survey-template-edit', {
        surveyId: 'new',
        cloneSurveyId: ctrl.survey.id,
      })
    }

    function validateSurvey() {
      if (ctrl.survey.validate()) {
        return $q.resolve()
      } else {
        ctrl.showErrors = true
        scrollService.animateTo('.survey-editor__error')

        if (ctrl.survey.ai.hasUnsaved) {
          var errors = ctrl.survey.aggregateErrors()
          $log.error(
            `AI Survey Builder validation error: `,
            JSON.stringify(errors)
          )
        }
        return $q.reject()
      }
    }

    function getQuestionLicense(question) {
      if (ctrl.survey.isTemplate) return
      return questionLicenseService.getForQuestion(
        question,
        subscriberService.getSubscriber()
      )
    }

    function getSurveyLicenseState() {
      return questionLicenseService.getSurveyState(
        ctrl.survey,
        subscriberService.getSubscriber()
      )
    }

    function getSurveyLicenseWarning() {
      var state = getSurveyLicenseState()
      if (!state) return

      return [
        'Warning! This survey contains ',
        state.shortLabels,
        ' questions that require a GMS license your organisation does not ',
        'have. The survey cannot be saved until those questions are removed ',
        'or the license is activated.',
      ].join('')
    }

    function ensureQuestionLicenses() {
      var state = getSurveyLicenseState()
      if (!state) return $q.resolve()

      var unremovableViews = _.reject(state.unlicensedViews, function(view) {
        return ctrl.survey.canRemoveView(view)
      })

      if (unremovableViews.length) {
        var reasons = []
        if (_.some(unremovableViews, { value: { isLocked: true } })) {
          reasons.push('one or more affected questions are locked')
        }
        if (
          ctrl.survey.hasActiveChannels() &&
          _.some(unremovableViews, function(view) {
            return !view.value.isNew
          })
        ) {
          reasons.push('the survey has active channels')
        }
        if (
          ctrl.survey.hasResponses() &&
          _.some(unremovableViews, function(view) {
            return !view.value.isNew
          })
        ) {
          reasons.push('the survey has collected responses')
        }

        return glDialog
          .alert(
            'Survey cannot be saved',
            [
              'This survey contains ',
              state.shortLabels,
              ' questions that require GMS licenses your organisation does ',
              'not have. The affected questions cannot be removed because ',
              reasons.join(' and '),
              '. ',
              '<a href="',
              ctrl.licenseContactHref,
              '" target="_blank">Contact Glow</a> to arrange access and ',
              'continue saving.',
            ].join(''),
            { locals: { closeText: 'Cancel' } }
          )
          .then(function() {
            return $q.reject()
          })
      }

      return glDialog
        .confirm(
          'Survey cannot be saved',
          [
            'This survey contains ',
            state.shortLabels,
            ' questions that require GMS licenses your organisation does ',
            'not have. Remove the affected questions to continue saving, or ',
            '<a href="',
            ctrl.licenseContactHref,
            '" target="_blank">Contact Glow</a> to arrange access.',
          ].join(''),
          {
            locals: {
              closeText: 'Remove and save',
              cancelText: 'Cancel',
            },
          }
        )
        .then(function() {
          _.each(state.unlicensedViews, function(view) {
            ctrl.survey.removeView(view)
          })
          ctrl.form.$setDirty()
          ctrl.survey.cleanUp()
        })
    }

    function doSave(isExplicit) {
      if (!uacService.canManageSurveys(true)) {
        return $q.reject()
      }
      return $q(function(resolve, reject) {
        var selected = getSelectedViews()
        var isNew = ctrl.survey.isNew()
        ctrl.showErrors = false

        surveyServiceNext
          .save(ctrl.survey)
          .then(function() {
            glToast.show('Your survey has been saved')

            ctrl.form.$setPristine()

            if (isNew) {
              track(
                ctrl.survey.templateId
                  ? 'create-from-template'
                  : 'create-from-scratch'
              )
              buildTitle()
              ctrl.onCreate({ $surveyId: ctrl.survey.id })
            } else {
              ctrl.onSave()
            }

            resolve()

            if (isExplicit === true) {
              broadcast('save')
            }

            // persist views selection
            _.each(selected, function(selectedView) {
              var view = _.find(ctrl.survey.views, {
                value: { id: selectedView.value.id },
              })
              if (view) view.selected = true
            })

            glTips.next()
          })
          .catch(function(data) {
            if (data.status === 409) {
              onSaveConflict(data.data.message)
            } else if (data.errors) {
              ctrl.showErrors = true
              scrollService.animateTo('.survey-editor__error')
            } else {
              glDialog.alert(
                'Error',
                'There was an issue saving your survey. Please try again.'
              )
            }
            reject()
          })
      })
    }

    function onSaveConflict(message) {
      var VERSION_REGEX = /\[\d+\]/
      var serverVersion = message.match(VERSION_REGEX)[0].slice(1, -1)
      ctrl.survey.serverVersion = +serverVersion

      var options = {
        templateUrl: 'survey-conflict-dialog.template.html',
        clickOutsideToClose: false,
        escapeToClose: false,
      }
      glDialog.show(options).then(function(action) {
        switch (action) {
          case 'overwrite':
            ctrl.survey.version = ctrl.survey.serverVersion
            save(true)
            break
          case 'discard':
            ctrl.onRefresh()
            break
        }
      })
    }

    function onUseAiMode() {
      if (ctrl.isAiModeDisabled) return
      var confirmed =
        ctrl.form.$dirty || ctrl.survey.ai.surveyModifiedByUser
          ? glDialog.confirm(
              'Warning!',
              'There are changes that have been made to this survey in the Manual Editor that will not be reflected in the AI mode. Do you want to continue?'
            )
          : $q.resolve()
      confirmed.then(function() {
        ctrl.onModeChange()
      })
    }

    function save(isExplicit, bypassWarning) {
      if (ctrl.isLoggedIn && !uacService.canManageSurveys(true)) return

      if (
        !bypassWarning &&
        ctrl.canUseAiMode &&
        !ctrl.isAiModeDisabled &&
        (ctrl.form.$dirty || !ctrl.survey.ai.surveyModifiedByUser) &&
        !ctrl.survey.ai.hasUnsaved &&
        ctrl.survey.ai.conversationId
      ) {
        return glDialog
          .confirm(
            'Warning!',
            'Any changes made to this survey in the Manual Editor will not be reflected in the AI mode. Do you want to continue?'
          )
          .then(function() {
            save(isExplicit, true)
          })
      }

      ctrl.survey.cleanUp()

      return validateSurvey()
        .then(ensureLogin)
        .then(ensureQuestionLicenses)
        .then(ensureProject)
        .then(function() {
          return doSave(isExplicit)
        })
        .then(function() {
          if (ctrl.didSignup) {
            return accountService.promptUpgrade({ context: 'welcome' })
          }
          // So that future saves don't prompt
          ctrl.didSignup = false

          if (ctrl.survey.ai.hasUnsaved) {
            ctrl.survey.ai.hasUnsaved = false
            pollAiBrief()
          } else {
            // Mark as user-modified so AI mode will show warning
            ctrl.survey.ai.surveyModifiedByUser = true
          }
        })
    }

    function ensureLogin() {
      if (ctrl.isLoggedIn) {
        return $q.resolve()
      }
      track('prompt-signup-on-save')
      return accountService
        .showAuthDialog('signup')
        .then(function(outcome) {
          ctrl.didSignup = outcome === 'signed-up'
        })
        .then(getUserInfo)
    }

    function getUserInfo() {
      ctrl.isLoggedIn = userService.isLoggedIn()
      ctrl.isSSR = userService.isSSR()
    }

    function ensureProject() {
      if (ctrl.survey.projectId || ctrl.survey.isTemplate) {
        return $q.resolve()
      }
      return projectService
        .load()
        .then(function(projects) {
          if (!projects.length) {
            if (!uacService.canManageProjects(true)) {
              return $q.reject()
            }
            var project = projectService.create()
            project.name = 'My First Glow Project'
            return projectService.save(project)
          } else if (projects.length === 1) {
            return projects[0]
          } else {
            return projectService
              .pick({ headerTitle: 'Add To Project' })
              .then(function(result) {
                return result.project
              })
          }
        })
        .then(function(project) {
          ctrl.survey.projectId = project.id
        })
    }

    function canPreview() {
      return !ctrl.survey.isNew() // must be saved at least once
    }

    function preview() {
      if (!canPreview()) return
      if (ctrl.form.$dirty) {
        glDialog
          .confirm(
            'Unsaved Changes',
            'Your survey has unsaved changes that will be lost. Do you want to continue?'
          )
          .then(function() {
            ctrl.isPreviewOverlay = true
          })
      } else {
        ctrl.isPreviewOverlay = true
      }
    }

    /**
     * @name canExport
     * @desc Determines whether or not a survey can be exported to JSON
     */
    function canExport() {
      return ctrl.survey.canExport() && ctrl.isSSR
    }

    /**
     * @name canImport
     * @desc Determines whether or not a survey can be imported from a JSON
     */
    function canImport() {
      return ctrl.survey.canImport() && ctrl.isSSR
    }

    function canClone() {
      return ctrl.survey.canClone()
    }

    function canCloneAsTemplate() {
      return ctrl.survey.id && ctrl.isSSR && !ctrl.survey.isTemplate
    }

    function clone() {
      accountService
        .promptUpgrade({
          bypassCondition: featureService.canCloneSurveys() || ctrl.isSSR,
          context: 'clone-survey',
        })
        .then(function() {
          if (!uacService.canManageSurveys(true)) return
          projectService
            .pick({
              headerTitle: 'Duplicate To Project',
            })
            .then(function(result) {
              glAnalytics.track('surveys', 'create-from-survey', ctrl.survey.id)
              $state.go('survey', {
                projectId: result.project.id,
                cloneSurveyId: ctrl.survey.id,
                surveyId: 'new',
              })
            })
        })
    }

    function changeType(view) {
      glDialog
        .confirm(
          'Change Type',
          [
            'Are you sure you want to change the type of this question? ',
            'Only the question title will be transferred to the new type.',
          ].join('')
        )
        .then(function() {
          var index = _.indexOf(ctrl.survey.views, view)
          var title = view.value.title
          viewPicker
            .showQuestionTypes('Change Type', {
              isSurveyTemplate: ctrl.survey.isTemplate,
            })
            .then(function(response) {
              var newView = addQuestion(response.value, index)
              newView.value.title = title
              newView.selected = view.selected
              ctrl.survey.removeView(view)
            })
        })
    }

    function saveQuestionAsTemplate(question) {
      var options = {
        title: 'Question Template',
        questionTemplate: questionTemplateService.createFromQuestion(question),
      }
      var template = [
        '<gl-dialog>',
        '<g-dialog-header ',
        'title="{{ title }}" ',
        'on-close="dialog.cancel()" ',
        '></g-dialog-header>',
        '<question-templates-editor template="questionTemplate" />',
        '</gl-dialog>',
      ]
      return glDialog.show({ template: template.join(''), locals: options })
    }

    function editIntro() {
      changeParams('intro')
      var clickedSave = false
      viewEditor
        .show(ctrl.survey.introView, null, ctrl.survey, ctrl.isForbidden)
        .then(function(data) {
          clickedSave = data.clickedSave
        })
        .finally(function() {
          changeParams(null)
          ctrl.survey.validateIntro()
          if (clickedSave) save(true)
        })
    }

    function editView(event, view) {
      var index = _.indexOf(ctrl.survey.views, view)
      if (event && event.defaultPrevented) {
        return
      }
      var clickedSave = false
      var viewValue =
        (view.type === View.Types.QUESTION ? 'q' : 's') + view.value.getNumber()
      changeParams(viewValue)

      viewEditor
        .show(view, index, ctrl.survey, ctrl.isForbidden)
        .then(function(data) {
          clickedSave = data.clickedSave
          if (data.clickedSaveAsTemplate) {
            saveQuestionAsTemplate(view.value)
          }
          if (data.clickedChangeType) {
            changeType(view)
          }
          if (data.clickedDuplicate) {
            ctrl.survey.cloneView(view)
            ctrl.form.$setDirty()
          }
          if (data.clickedDelete) {
            var viewIndex = view.getIndex()
            var viewTitle = view.getTitleLabel({ number: true })
            ctrl.survey.removeView(view)
            ctrl.form.$setDirty()
            glToast.action(
              viewTitle + ' deleted',
              'Undo',
              function() {
                ctrl.survey.addView(view, viewIndex, true)
              },
              { timeout: 10000, maxOpened: 10 }
            )
          }
        })
        .finally(function() {
          changeParams(null)
          view.value.validate()
          if (clickedSave) save(true)
        })
    }

    function isUnloadConfirmation() {
      if (ctrl.survey.templateId && ctrl.survey.isNew()) {
        return true
      }
      return ctrl.form && ctrl.form.$dirty
    }

    function getLOIEstimate() {
      return _.round(ctrl.survey.getLOIEstimate('loi widget') / 60, 1)
    }

    function editSettings() {
      var template = [
        '<gl-dialog class="survey-settings__dialog">',
        '<survey-settings ',
        'survey="survey"',
        'is-forbidden="isForbidden"',
        'on-done="dialog.close({settingsUpdated: $isDirty, clickedSave: $clickedSave});" ',
        '/>',
        '</gl-dialog>',
      ]
      var options = {
        template: template.join(''),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          survey: ctrl.survey,
          isForbidden: ctrl.isForbidden,
        },
      }
      return glDialog.show(options).then(function(data) {
        if (data.clickedSave) save(true)
        return data.settingsUpdated && ctrl.form.$setDirty()
      })
    }

    function editTranslations() {
      translationService.showManager(ctrl.survey)
    }

    function showLoopDialog() {
      // prettier-ignore
      var template = [
        '<gl-dialog class="loop-dialog__dialog">',
          '<loop-dialog ',
            'survey="survey"',
            'on-done="dialog.close()" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      var options = {
        template: template.join(''),
        clickOutsideToClose: false,
        escapeToClose: true,
        locals: {
          survey: ctrl.survey,
        },
      }
      return glDialog.show(options)
    }

    function showExportDOCXDialog() {
      // prettier-ignore
      var template = [
        '<gl-dialog class="export-docx-dialog__dialog">',
          '<export-docx-dialog ',
            'survey="survey"',
            'on-done="dialog.close()" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      var options = {
        template: template.join(''),
        clickOutsideToClose: false,
        escapeToClose: true,
        locals: {
          survey: ctrl.survey,
        },
      }
      return glDialog.show(options)
    }

    function onKeyDown(e) {
      var hasActiveDialog = glDialog.isActive()
      var isInputEl = e.target.localName === 'input'
      var isTextareaEl = e.target.localName === 'textarea'
      if (hasActiveDialog || isInputEl || isTextareaEl) {
        return
      }
      var modifierKey = ctrl.isMacOS ? e.metaKey : e.ctrlKey
      if (modifierKey && e.keyCode === 70) {
        e.preventDefault()
        ctrl.showFindAndReplaceDialog(ctrl.survey)
      }
    }

    function changeParams(viewValue) {
      glUtils.changeParams({ [ctrl.viewParamKey]: viewValue }, null, false)
    }

    function onDestroy() {
      window.removeEventListener('keydown', onKeyDown)
    }
  }
})()
